import { KIOSK_PALETTE } from "../../../app/theme/checkIn";

/**
 * The entrance kiosk's fixed palette and type (approved business-B kiosk
 * frames, #2691). A kiosk is a single-purpose device read from across the
 * room, so it does not follow the player app's light/dark scheme.
 */
export const KIOSK = {
  ...KIOSK_PALETTE,
  font: '"Hanken Grotesk", Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif',
  mono: '"Space Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
} as const;

/**
 * Scale a size drawn on the 1180 × 820 landscape frame to any tablet: the
 * approved px value on that frame, proportionally smaller on smaller screens.
 * 820 px is the frame's short side.
 */
export function kpx(px: number): string {
  return `min(${px}px, ${((px / 820) * 100).toFixed(3)}vmin)`;
}

export const KIOSK_FONT_HREF =
  "https://fonts.googleapis.com/css2?family=Hanken+Grotesk:wght@400;500;600;700&family=Space+Mono:wght@400;700&display=swap";
